<div class="login-bg">
  <div class="row w-100 align-items-center">
    <div class="col-lg-6 d-flex">
      <div class="auth-logo m-auto">
        <img src="assets/images/admin-logo-v2.png" class="img-fluid" alt="" />
      </div>
    </div>
    <div class="col-lg-6">
      <div class="splash-container login-wrap d-flex align-items-center">
        <div class="card px-2 py-5 mb-0">
          <div class="card-body">
            <div class="headbox text-center">
              <h1>Sign Up</h1>
              <span class="splash-description">Please enter your user information.</span>
            </div>
            <div class="middle-area">
              <form [formGroup]="registrationForm" (ngSubmit)="onSubmit()">
                <div class="form-group mb-4">
                  <input type="text" class="form-control form-control-lg" formControlName="name" placeholder="Name"  pattern="[a-zA-Z ]*"  (input)="onInput($event)"
                 required [ngClass]="{ 'is-invalid': submitted && registrationForm.get('name')?.hasError('required') || registrationForm.get('name')?.hasError('forbiddenCharacters')}"/>
                    <div class="invalid-feedback">
                    <div
                      *ngIf="registrationForm.get('name')?.hasError('required') && registrationForm.get('name')?.touched"
                      class="error-message">Name is required</div>
                    <div *ngIf="registrationForm.get('name')?.hasError('forbiddenCharacters')"  class="error-message">
                      Name contains special characters.
                    </div>
                  </div>
                </div>
                <div class="form-group mb-4">
                  <input type="email" class="form-control form-control-lg" formControlName="email" placeholder="Email"
                    required
                    [ngClass]="{ 'is-invalid': submitted && registrationForm.get('email')?.hasError('required')}" />
                  <div class="invalid-feedback">
                    <div
                      *ngIf="registrationForm.get('email')?.hasError('required') && registrationForm.get('email')?.touched"
                      class="error-message">Email is required</div>
                    <div
                      *ngIf="registrationForm.get('email')?.hasError('email') && registrationForm.get('email')?.touched"
                      class="error-message">Invalid email format</div>
                  </div>
                </div>
                <!-- <div class="form-group mb-4">
                    <input type="text" class="form-control" formControlName="country_code" placeholder="Country Code" />
                    <div *ngIf="registrationForm.get('country_code')?.hasError('required') && registrationForm.get('country_code')?.touched" class="error-message">Country Code is required</div>
                  </div> -->
                <div class="form-group mb-4">
                  <div class="reg-phone">
                    <div class="c-code"><img src="assets/images/uae-flag-icon.png" class="img-fluid mr-2" alt="" /> +971
                    </div>
                    <input type="number" class="form-control form-control-lg" maxlength="9"
                      oninput="this.value = this.value.slice(0, 9)" formControlName="mobile" placeholder="Mobile Number"
                      required
                      [ngClass]="{ 'is-invalid': submitted && registrationForm.get('mobile')?.hasError('required')}"
                      required />
                    <div class="invalid-feedback">
                      <div
                        *ngIf="registrationForm.get('mobile')?.hasError('required') || registrationForm.get('mobile')?.touched"
                        class="error-message">Enter Mobile Number</div>
                      <div
                        *ngIf="registrationForm.get('mobile')?.hasError('pattern') && registrationForm.get('mobile')?.touched"
                        class="error-message">Invalid mobile number format</div>
                    </div>
                  </div>

                </div>
               
            <div class="form-group mb-4 position-relative">
              <input type="{{pwdType ? 'password' : 'text'}}" class="form-control form-control-lg"
                formControlName="password" placeholder="Password" required
                [ngClass]="{ 'is-invalid': submitted && registrationForm.get('password')?.hasError('required')}" />
              <div class="eye-icon" (click)="togglePwdType()" style="cursor: pointer;">
                <span class="material-symbols-sharp">{{pwdType ? 'visibility_off' : 'visibility'}}</span>
              </div>
              <div class="invalid-feedback">
                <div
                  *ngIf="registrationForm.get('password')?.hasError('required') && registrationForm.get('password')?.touched"
                  class="error-message">Password is required</div>
                <div
                  *ngIf="registrationForm.get('password')?.hasError('minlength') && registrationForm.get('password')?.touched"
                  class="error-message">Password should be at least 8 characters</div>
              </div>
            </div>
            <div class="form-group mb-3 position-relative">
              <input type="{{confirmPwdType ? 'password' : 'text'}}" class="form-control form-control-lg"
                formControlName="confirm_password" placeholder="Confirm Password" required
                [ngClass]="{ 'is-invalid': submitted && registrationForm.get('confirm_password')?.hasError('required') || registrationForm.hasError('passwordMismatch') || registrationForm.get('confirm_password')?.hasError('minlength')}" />
              <div class="eye-icon" (click)="toggleConfirmPwdType()" style="cursor: pointer;">
                <span class="material-symbols-sharp">{{confirmPwdType ? 'visibility_off' : 'visibility'}}</span>
              </div>
              <div class="invalid-feedback">
                <div
                  *ngIf="registrationForm.get('confirm_password')?.hasError('required') && registrationForm.get('confirm_password')?.touched"
                  class="error-message">Confirm Password is required</div>
                <div
                  *ngIf="registrationForm.get('confirm_password')?.hasError('minlength') && registrationForm.get('confirm_password')?.touched"
                  class="error-message">Confirm Password should be at least 8 characters</div>
                <div *ngIf="registrationForm.hasError('passwordMismatch')" class="error-message">Confirm Passwords
                  do not match.</div>
              </div>
            </div>
            <div class="btn-wrap text-center mt-5">
              <button class="btn btn-lg btn-block btn-primary" type="submit">Register</button>
            </div>
            </form>
          </div>
        </div>
        <div class="card-footer bg-white pt-3 d-flex">
          <div class="card-footer-item card-footer-item-bordered">Already have an account
            <a routerLink="/login" routerLinkActive="active" class="red-link">Login</a>
          </div>
          <!-- <div class="card-footer-item card-footer-item-bordered">
                  <a href="#" class="footer-link">Forgot Password</a>
              </div> -->
        </div>
      </div>
    </div>
  </div>
</div>
</div>